export default __webpack_public_path__ + "static/tertiary-1-6b9dcfedf64bd2fe234a663818ebd2b8.jpg";